import React from 'react';
import PropTypes from 'prop-types';
import { fieldPropTypes } from 'redux-form';
import { DatePickerSimpleField } from 'components/FormFieldsSimple/DatePickerSimpleField';
import { ReduxFormElementWrapper } from '../_ReduxFormElementWrapper';
import moment from 'moment';

export class DatePickerField extends React.PureComponent {
  static propTypes = {
    ...fieldPropTypes,
    dateFormat: PropTypes.string,
    position: PropTypes.oneOf(['left', 'right', 'center']),
  };

  static defaultProps = {
    dateFormat: 'MM/DD/YYYY',
  };

  handleChange = (value) => {
    const { input } = this.props;
    input.onFocus();
    input.onChange(value);
    input.onBlur();
  };

  render() {
    const { input, position, disabled } = this.props;

    return (
      <ReduxFormElementWrapper {...this.props} childrenMarginTop="14px">
        <DatePickerSimpleField
          {...this.props}
          onChange={this.handleChange}
          position={position}
          disableDatepicker={disabled}
          value={moment(input.value)}
          onFocus={input.onFocus}
          onBlur={input.onBlur}
        />
      </ReduxFormElementWrapper>
    );
  }
}
